import { useState } from 'react';
import { useEmployee } from './EmployeeContext';
import { useModal } from '../../components/ModalProvider';
import { employeeApi } from '../../lib/api';
import { getCurrentPosition } from '../../lib/photo';
import { waLink } from '../../lib/whatsapp';
import { errorMessage } from '../../components/ErrorModalBody';

const NUMERO_EMERGENCIA = '71991588139';
const LOCAIS_RAPIDOS = ['Bar', 'Entrada', 'Banheiro', 'Camarim/Backstage', 'Pista', 'Palco'];

function SosConfirmModal({ onConfirm }: { onConfirm: (local: string) => void }) {
  const [local, setLocal] = useState('');
  const { closeModal } = useModal();

  return (
    <>
      <h2>Precisa de ajuda?</h2>
      <p className="hint">Isso avisa o gestor imediatamente, com sua localização. Use só em caso de emergência de verdade.</p>
      <label>Onde você está exatamente? (opcional, mas ajuda muito)</label>
      <input type="text" placeholder="ex: perto do bar, banheiro masculino..." value={local} onChange={(e) => setLocal(e.target.value)} />
      <div className="row" style={{ marginTop: 8, flexWrap: 'wrap', gap: 6 }}>
        {LOCAIS_RAPIDOS.map((l) => (
          <button key={l} type="button" className="pill pill-tag" style={{ border: 'none', cursor: 'pointer' }} onClick={() => setLocal(l)}>{l}</button>
        ))}
      </div>
      <button className="btn btn-primary btn-block" style={{ marginTop: 14, background: 'var(--coral)', borderColor: 'var(--coral)' }} onClick={() => onConfirm(local.trim())}>Sim, preciso de ajuda agora</button>
      <button className="btn btn-ghost btn-block" style={{ marginTop: 8 }} onClick={closeModal}>Cancelar</button>
    </>
  );
}

export function SosButton() {
  const { employee } = useEmployee();
  const { showModal, closeModal } = useModal();
  const [sending, setSending] = useState(false);

  async function confirmarSos(local: string) {
    setSending(true);
    try {
      let lat: number | null = null, lng: number | null = null, accuracy: number | null = null;
      try {
        const pos = await getCurrentPosition();
        lat = pos.coords.latitude; lng = pos.coords.longitude; accuracy = Math.round(pos.coords.accuracy);
      } catch {
        // segue sem localização — o aviso é mais importante que a coordenada
      }
      await employeeApi.triggerSos({ lat, lng, accuracy, local: local || null });

      const mapa = lat && lng ? ` Localização: https://maps.google.com/?q=${lat},${lng}` : '';
      const ondeMsg = local ? ` Onde: ${local}.` : '';
      const mensagem = `🚨 SOS: ${employee.nome} (${employee.camarote || 'sem camarote'}) precisa de ajuda agora!${ondeMsg}${mapa}`;
      window.open(waLink(NUMERO_EMERGENCIA, mensagem), '_blank', 'noreferrer');

      showModal(<>
        <h2>Gestor avisado ✓</h2>
        <p className="hint">Sua localização e um alerta foram enviados agora. Abrimos o WhatsApp também, como reforço — pode enviar a mensagem por lá também se conseguir.</p>
        <button className="btn btn-primary btn-block" onClick={closeModal}>Fechar</button>
      </>);
    } catch (err) {
      showModal(<>
        <h2 style={{ color: 'var(--coral)' }}>Não foi possível avisar agora</h2>
        <p className="muted">{errorMessage(err)}</p>
        <button className="btn btn-primary btn-block" onClick={closeModal}>Fechar</button>
      </>);
    } finally {
      setSending(false);
    }
  }

  function abrirConfirmacao() {
    if (sending) return;
    showModal(<SosConfirmModal onConfirm={confirmarSos} />);
  }

  return (
    <button
      onClick={abrirConfirmacao}
      title="SOS — pedir ajuda"
      aria-label="SOS — pedir ajuda ao gestor"
      style={{
        position: 'fixed', bottom: 78, left: 14, zIndex: 30,
        width: 40, height: 40, borderRadius: '50%',
        background: 'var(--coral)', border: 'none', color: '#fff',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 17, fontWeight: 800, boxShadow: 'var(--shadow)', cursor: 'pointer',
      }}
    >
      🆘
    </button>
  );
}
